import React from 'react'
import {broadcast, listen, stop_listen} from '../../utils'
import {chat_notifications_layer} from '../../utils/chat_utils'
import './index.css'

class Notifications extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mode: 'cursor',
      token: "",
      mouse_down_coords: false,
      is_closed: true,
      container_mouse_coords: false,
      top: 10,
      left: 30,
      notifications: [],
      hidden: false,
      listners: []
    }
  }

  componentDidMount(){
    const listners = [
      {type: "containter_onMouseMove", fnc: ({detail}) => {
        this.setState({container_mouse_coords: [detail.clientX, detail.clientY]})
        if (!!this.state.mouse_down_coords)
          this.setState({
            top: this.state.top + (detail.clientY - this.state.mouse_down_coords[1]),
            left: this.state.left + (detail.clientX - this.state.mouse_down_coords[0]),
            mouse_down_coords: [detail.clientX, detail.clientY]
          })
      }},
      {type: "toolbar_mode_change", fnc: ({detail}) => {
        if (detail.mode === "notifications" && this.state.mode !== "notifications"){
          this.setState({mode: detail.mode, is_closed: false})
          broadcast("toolbar_mode_change", {mode: 'cursor'})
        } else {
          this.setState({mode: detail.mode})
        }
      }},
      {type: "current_user", fnc: ({detail}) => this.setState({token: detail.access_token})},
      {type: "notifications", fnc: ({detail}) => {
        this.setState({notifications: detail})

        detail.forEach(v => {
          if (v.new_messages_count > 0){
            broadcast(
              "add_or_replace_layer",
              chat_notifications_layer(`${v.chat_id}_notifications`, v.coords, v.new_messages_count)
            )
          } else {
            broadcast("remove_layer", `${v.chat_id}_notifications`)
          }
        })
      }},
    ]

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  componentWillUnmount(){this.state.listners.forEach(l => stop_listen(l.type, l.fnc))}

  render() {
    if (!this.state.is_closed){
      return(
        <div
          className="polygon-tool"
          style={{
            top: this.state.top,
            left: this.state.left,
            width: "400px"
          }}
        >
          <div
            className="tool-header"
            onMouseDown={e => this.setState({mouse_down_coords: this.state.container_mouse_coords})}
            onMouseUp={e => this.setState({mouse_down_coords: false})}
          >
            <span className="tool-header-title">&nbsp;уведомления</span>
            <div className="tool-header-btns">
              <span
                className="tool-header-btn"
                onClick={() => this.setState({hidden: !this.state.hidden})}
              >{this.state.hidden ? "▾" : "▸"}</span>
              <span
                className="tool-header-btn"
                style={{transform: `rotateZ(45deg)`}}
                onClick={() => {
                  broadcast("toolbar_mode_change", {mode: 'cursor'})
                  broadcast("layer_edit", {id: false, type: "notifications"})
                  this.setState({is_closed: true})
                }}
              >+</span>
            </div>
          </div>
          {
            this.state.hidden ? null :
              <div className="chat-messages-cont">
                {
                  this.state.notifications.map((v, i) => {
                    const fdate = new Date(v.first_m_time * 1000)
                    const fday = parseInt(fdate.toLocaleString().slice(0,2))
                    const fday_w = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"][fdate.getDay()]
                    const fmonth = ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"][fdate.getMonth()]
                    var ftime = fdate.toLocaleTimeString().slice(0,5)

                    const ldate = new Date(v.last_m_time * 1000)
                    const lday = parseInt(ldate.toLocaleString().slice(0,2))
                    const lday_w = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"][ldate.getDay()]
                    const lmonth = ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"][ldate.getMonth()]
                    var ltime = ldate.toLocaleTimeString().slice(0,5)

                    var time_slice = ``

                    if (lday === fday && lmonth === fmonth){
                      if (ftime !== ltime) {
                        time_slice = `${ftime}-${ltime} ${lday_w} ${lday} ${lmonth}`
                      } else {
                        time_slice = `${ftime} ${lday_w} ${lday} ${lmonth}`
                      }
                    } else {
                      ftime = `${ftime} ${fday_w} ${fday} ${fmonth}`
                      ltime = `${ltime} ${lday_w} ${lday} ${lmonth}`
                      time_slice = `${fday_w} ${fday} ${fmonth} - ${lday_w} ${lday} ${lmonth}`
                    }


                    return(<div
                        className="notification-message"
                        key={`notif_chat_${v.chat_id}_${i}`}
                        style={{
                          borderTop: `${i === 0 ? 0 : 2}px solid rgb(245, 247, 249)`,
                          paddingTop: "4px"
                        }}
                        onClick={() => broadcast("set_map_coords", v.coords)}
                      >
                        <div className="chat-message-header">
                          <div className="chat-message-header-user">
                            <img
                              alt=""
                              className="chat-message-header-img"
                              src={v.picture}
                            />
                            <span className="chat-message-header-username">
                              {v.user_name}
                            </span>
                          </div>
                          <span className="chat-message-header-date">
                            {time_slice}
                          </span>
                        </div>

                        <div className="chat-message-body"
                        >{v.title}
                          {
                            v.new_messages_count > 0 ? <span
                                className="notifications-notification-count"
                              >
                                {v.new_messages_count}
                              </span> : null
                          }
                        </div>
                      </div>
                    )
                  })
                }
              </div>
          }
        </div>
      )
    } else {
      return(null)
    }
  }
}

export default Notifications;
